import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVloerWandPlafond1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M28.5 9.67v20.66L34 34V6zM27.5 10h-15v20h15z"
    />
    <path
      fill="#00C5F2"
      d="M11.5 9.67 6 6v28l5.5-3.67z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M19.5 32V8h1v24z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m20 7.293 2.354 2.353-.707.708L20 8.707l-1.646 1.647-.707-.708zM20 31.293l-1.646-1.647-.707.708L20 32.707l2.354-2.353-.707-.708zM9 19.5h11v1H9z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m9.707 20 1.646-1.646-.707-.708L8.293 20l2.353 2.354.707-.708z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVloerWandPlafond1);

export default ForwardRef;
